module.exports = __webpack_public_path__ + "img/loan_no_ok.d0de1bfc.png";